const DEVICE_STATE = '/device-state';

export const ROUTE_HOME_DEVICE_STATE = DEVICE_STATE + '/home';

export const deviceStateRoutes = [ROUTE_HOME_DEVICE_STATE];
